import App from "./App.vue";
import Utils from "./plugins/utils";
import Vue from "vue";
import VuePlayerPlugin from 'vue-youtube-iframe-api';
import VueYoutube from 'vue-youtube';
import router from "./router";

// kick off the polyfill!
Vue.config.productionTip = false;
Vue.config.silent = false;

Vue.use(Utils);
Vue.use(VueYoutube);
Vue.use(VuePlayerPlugin, {
  with: '',
  height: '',
  loadComponent: true
})

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
